import {
  Autocomplete,
  Backdrop,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../../customTable";
import moment from "moment";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { CloseOutlined } from "@mui/icons-material";
import MonthReports from "./monthReports";
import DayReports from "./dayReports";
import ProductReport from "./productReport";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from '@mui/icons-material/Visibility';
const ExpensesLedger = () => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [cust, setCust] = useState(null);
  const [open, setOpen] = useState(false);
  const [monthData, setMonthData] = useState([]); //month api
  const [dateData, setDateData] = useState([]); //date api
  const [productData, setProductData] = useState([])
  const [activeStep, setActiveStep] = useState("0");
  const [dateLimit, setDateLimit] = useState({
    fromDate: moment().subtract(1 ,'years').format("YYYY"),
    toDate: moment().format("YYYY"),
  });
  const onEdit = (e) => {
    console.log(e.row);
    getMonthData(e.row.month, e.row.year);
    setOpen(true);
  };
  // const onEditDate = (e) => {
  //     console.log(e.row)
  //     getDateData(e.row.date)
  //     setOpen(true)
  // }
  function getMonthData(month, year) {
    console.log(month, year);
    axios
      .get(`/v1/reports/outlet_expenceledger/month/${year}/${month}`)
      .then((res) => {
        console.log(res);
        setMonthData(res.data);
      })
      .catch((err) => {
        console.log(err.response.data.error);
        setMonthData([])
        dispatch(setSnackbar("true" , 'error' , err.response.data.error))
      });
  }
  function getDateData(date) {
    console.log(date);
    axios
      .get(`/v1/reports/outlet_expenceledger/day/${rowsPerPage}/${page + 1}/${date}`)
      .then((res) => {
        console.log(res.data);
        setDateData(res.data);
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          setSnackbar(true, "error", err.response.data.error)
        );
      });
  }
  const columns = [
    {
      field: "sno",
      headerName: "S.no",
      minWidth: 70,
      maxWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "month",
      headerName: "Month",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "cash",
      headerName: "Cash",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
   
    {
      field: "view",
      headerName: "View",
      flex: 1,
      disableExport: true ,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <IconButton size="small" onClick={() => onEdit(params)}>
            <VisibilityIcon />
          </IconButton>
        );
      },
    },
  ];

  const rows = _.map(data, (val, idx) => ({
    id: idx,
    sno: idx + 1,
    month: val.month,
    cash: val.amount,
    year: val.year,
  }));
  // const monthColumns = [
  //     {
  //         field : 'sno',
  //         headerName : 'S.no',
  //         minWidth : 70,
  //         maxWidth : 100,
  //         headerAlign : 'center',
  //         align : 'center',
  //         sortable: false
  //       },
  //       {
  //         field: "date",
  //         headerName: "Date",
  //         flex: 1,
  //         headerAlign: "center",
  //         align: "center",
  //         sortable: false,
  //       },
  //       {
  //         field: "noOfSales",
  //         headerName: "No.of Sales",
  //         flex: 1,
  //         headerAlign: "center",
  //         align: "center",
  //         sortable: false,
  //       },
  //       {
  //         field: "view",
  //         headerName: "View",
  //         flex: 1,
  //         headerAlign: "center",
  //         align: "center",
  //         sortable: false,
  //         renderCell : (params) => {
  //             return(
  //                 <IconButton
  //                 size="small"
  //                 onClick={() => onEditDate (params)}
  //                 >
  //                     <EditRoundedIcon />
  //                 </IconButton>
  //             )
  //         }
  //       },
  // ]
  // const monthRows =_.map(monthData.details,(value,idx) =>({
  //     id: idx,
  //     sno: idx+1,
  //     date:moment(value.date).format('YYYY-MM-DD'),
  //     noOfSales:value.no_of_sales
  // }))
  // const props = {
  //   columns : columns,
  //   rows : rows,
  //   page: page,
  //   setPage: setPage,
  //   rowsPerPage: rowsPerPage,
  //   setRowsPerPage: setRowsPerPage,
  //   pageCount: pageCount,
  //   pageOption: pageOption,
  // }
  const props = {
    columns: columns,
    rows: rows,
    page: page,
    setPage: setPage,
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage,
    pageCount: pageCount,
    pageOption: pageOption,
  };
  // const innerProps = {
  //     columns : monthColumns,
  //     rows : monthRows,
  //     page: page,
  //     setPage: setPage,
  //     rowsPerPage: rowsPerPage,
  //     setRowsPerPage: setRowsPerPage,
  //     pageCount: pageCount,
  //     pageOption: pageOption,
  //   }
  function handleChange(e, name) {
    setDateLimit((prev) => ({ ...prev, [name]: dayjs(e).format("YYYY") }));
  }

  function handleGetData() {
    axios
      .post(`/v1/reports/outlet_expenceledger/year/${dateLimit.fromDate}/${dateLimit.toDate}`)
      .then((res) => {
        setData(res.data);
        console.log(res.data);
        setPageCount(res.data.length)
      })
      .catch((err) => {
        dispatch(
          setSnackbar(true, "error", err.response.data.errors[0].message)
        );
      });
  }
  useEffect(() => {
    if (dateLimit.fromDate !== null && dateLimit.toDate !== null) {
      handleGetData();
    }
  }, [rowsPerPage, page, dateLimit]);
  console.log(productData);
  return (
    <Fragment>
      <Helmet><title>Outlet Expenses Ledger</title></Helmet>
      <Typography variant="h6">Outlet Expenses Ledger</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              views={["year"]}
              openTo="year"
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              slotProps={{
                textField: {
                  size: "small",
                  label: "From",
                  style: { width: "100%" },
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              views={["year"]}
              openTo="year"
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              slotProps={{
                textField: {
                  size: "small",
                  label: "To",
                  style: { width: "100%" },
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <CustomTable props={props} />
      <Backdrop open={open} sx={{ zIndex: 1500 }}>
        <Grid
          sx={{
            width: "80%",
            maxHeight: "80vh",
            backgroundColor: "#fff",
            borderRadius: "5px",
          }}
        >
          {activeStep === "0" ? (
            <MonthReports
              setOpen={setOpen}
              monthData={monthData}
              getDateData={getDateData}
              setActiveStep={setActiveStep}
            />
          ) : activeStep === "1" ? (
            <DayReports
              dateData={dateData}
              setOpen={setOpen}
              setActiveStep={setActiveStep}
              setProductData={setProductData}
            />
          ) : activeStep === "2" ? (
            <ProductReport setActiveStep={setActiveStep}
            setOpen={setOpen} dateData={productData} />
          ) : null}
        </Grid>
      </Backdrop>
    </Fragment>
  );
};

export default memo(ExpensesLedger);
